import { createFileRoute } from "@tanstack/react-router";

import FormSkeleton from "@/components/loadings/skeleton/FormSkeleton";
import { type ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ProfileBuilder from "@/modules/profile/admin/components/ProfileBuilder";
import { fetchProfileBuilderQueryOptions } from "@/modules/profile/admin/services";

export const Route = createFileRoute("/admin/_panel/_profile/profile/")({
  component: Component,
  pendingComponent: FormSkeleton,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchProfileBuilderQueryOptions()),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "profile.profile-builder.update");

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [],
    } satisfies ChildRouteContext;
  },
});

function Component() {
  return <ProfileBuilder />;
}
